import { makeGetNetworkRequest } from '../hooks/network/Network';

export const forecastTimeRangesQuery = makeGetNetworkRequest({
  path: '/api/v1/kitchen/orders/forecasting/timeRanges'
});
